import React from 'react';
import Button from './Button'; 
import { useAuth } from '../middleware/AuthContext'; // Import the useAuth hook

const SubscriptionLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading, logout, login, userRole } = useAuth(); // Use auth context

  if (loading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>; 
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <header className="bg-gray-800 text-white py-4 shadow-md">
        <div className="container mx-auto flex justify-between items-center px-4 md:px-8">
          <div>
            <h1 className="text-3xl font-bold">Announcement Tool</h1>
            <p className="text-lg text-white">Announcement Assistant Tool for CARIAD Estonia</p>
          </div>

          <div className="flex items-center space-x-10 ml-auto">
            {user ? (
              <>

                {/* Profile Section */}
              <div className="flex items-center space-x-4"> 
                <Button variant="primary" onClick={logout}>Logout</Button>
                <div className="flex flex-col text-right">
                  <span className="font-semibold">{user}</span>
                  <span className="text-sm text-gray-300 italic">{userRole}</span>
                </div>
              </div>
              </>
            ) : (
              <Button variant="primary" onClick={() => login()}>Login</Button>
            )}
          </div>
        </div>
      </header>

      <main className="flex-grow container mx-auto px-4 md:px-8 py-8">{children}</main>

      <footer className="bg-gray-800 text-white py-4 text-center">
      <p className="text-sm"> All rights reserved. Copyright © {new Date().getFullYear()} Announcement Tool by CARIAD Estonia AS </p>
      </footer>
    </div>
  );
};

export default SubscriptionLayout;
